


































import TemplateSelection from '@/views/TemplateSelection.vue';
import CreateDocumentValuation from '@/views/CreateDocumentValuation.vue';
import CreateDocumentCompany from '@/views/CreateDocumentCompany.vue';
import CreateDocumentCompetitors from '@/views/CreateDocumentCompetitors.vue';
import CreateDocumentClosingMeeting from '@/views/CreateDocumentClosingMeeting.vue';
import CreateDocumentYearEndMeeting from '@/views/CreateDocumentYearEndMeeting.vue';
import CreateDocumentPreClosingMeeting from '@/views/CreateDocumentPreClosingMeeting.vue';
import CreateDocumentFutureMeeting from '@/views/CreateDocumentFutureMeeting.vue';
import CreateDocumentYearReview from '@/views/CreateDocumentYearReview.vue';
import {Component, Prop, Vue} from 'vue-property-decorator';
import * as api from '@/store/api';
import user from '@/store/modules/user';
import DocumentEditor from '@/views/document/DocumentEditor.vue';
import AboutDocument from '@/views/document/AboutDocument.vue';

@Component({
  components: {
    AboutDocument,
    DocumentEditor, CreateDocumentClosingMeeting, CreateDocumentCompetitors, CreateDocumentCompany,
    CreateDocumentValuation, TemplateSelection, CreateDocumentPreClosingMeeting, CreateDocumentFutureMeeting,
    CreateDocumentYearEndMeeting, CreateDocumentYearReview,
  },
})
export default class EditDocument extends Vue {
  doc: any = {};

  async mounted() {
    if (user.selectedDocumentBlob) {
      const doc = await api.getDocumentPlain(user.selectedDocumentBlob);
      if (!doc.DocumentId) {
        doc.DocumentId = user.selectedDocument;
      }
      this.doc = doc;
    }
    if (!this.doc.DocumentId) {
      await this.$router.push({name: 'start'});
    }
  }

  get documentId() {
    return user.selectedDocument;
  }

  get documentBlobId() {
    return user.selectedDocumentBlob;
  }

  get typed() {
    if (this.doc.Type !== 'typed') {
      return false;
    }
    switch (this.doc.SubType) {
      case 'flexible':
      case 'cashflow':
      case 'company':
      case 'industryAnalysis':
      case 'competitorAnalysis':
      case 'webreport_cashflow':
      case 'preClosingMeeting':
        return true;
    }
    return false;
  }

  prev() {
    this.$router.back();
  }
}
